var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.1,
    fill: "#FAA100",
    cx: 25.5,
    cy: 25.5,
    r: 25.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 18)",
    fill: "#F6B119",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.063 0H.938A.926.926 0 0 0 0 .914v13.172c0 .505.42.914.938.914h22.125a.926.926 0 0 0 .937-.914V.914A.926.926 0 0 0 23.062 0zm-.82 10.548a.694.694 0 0 1-.703.686c-.774 0-1.405.614-1.405 1.37a.694.694 0 0 1-.703.684H4.568a.694.694 0 0 1-.703-.685c0-.755-.63-1.37-1.405-1.37a.694.694 0 0 1-.704-.685V4.452c0-.379.315-.686.704-.686.774 0 1.405-.614 1.405-1.37 0-.378.314-.684.703-.684h14.864c.389 0 .703.306.703.685 0 .755.63 1.37 1.405 1.37.39 0 .704.306.704.685v6.096z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.818 3.082H5.182a2.788 2.788 0 0 1-2.02 1.968v4.9a2.788 2.788 0 0 1 2.02 1.968h13.636a2.788 2.788 0 0 1 2.02-1.968v-4.9a2.788 2.788 0 0 1-2.02-1.968zM6.773 8.185H6a.694.694 0 0 1-.703-.685c0-.378.314-.685.703-.685h.773c.388 0 .703.307.703.685a.695.695 0 0 1-.703.685zM12 10.06c-1.448 0-2.627-1.148-2.627-2.56 0-1.412 1.179-2.56 2.627-2.56 1.448 0 2.627 1.148 2.627 2.56 0 1.412-1.179 2.56-2.627 2.56zm6-1.875h-.773a.695.695 0 0 1-.703-.685c0-.378.315-.685.703-.685H18c.389 0 .703.307.703.685a.694.694 0 0 1-.703.685z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 7.5,
    rx: 1.221,
    ry: 1.19
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/points.8247c45cd8cbbe36c977eccfb30a5f88.svg";
export { ForwardRef as ReactComponent };